import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  formatDateTimezon,
} from "../common-data/Converts";
import PaginationModified from "../../data/PaginationModified";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  DownloadIcon,
} from "../../images/icons/icons";

const CheckedinMembersMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  setClickValues,
  loading,
  handleDelete,
  userInfoData,
  pageLimit,
  setPageLimit,
}) => {
  const isAdmin = userInfoData?.account_type === "admin";

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isFirstBCA = row?.bca_report;

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number">{row?.user_mobile || "NA"}</p>
                      {row?.email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value flex-col">
                            <span className="label">Regular Plan</span>
                            <span className="value">
                              <small
                                className="underline"
                                style={{ color: "gray" }}
                              >
                                {row?.date_added
                                  ? formatDateTimezon(row.date_added)
                                  : "-"}
                              </small>
                              <br />

                              <small className="underline">
                                {row?.regular_start_date
                                  ? formatDateTimezon(row.regular_start_date)
                                  : "-"}
                                <b> - </b>
                                {row?.regular_expire_date
                                  ? formatDateTimezon(row.regular_expire_date)
                                  : "-"}
                              </small>
                              <br />

                              <small
                                style={{
                                  background:
                                    row?.current_plan_status === "active"
                                      ? "#0A701B"
                                      : "#F13434",
                                  color: "#fff",
                                  borderRadius: "8px",
                                  padding: "5px 10px",
                                  textDecoration: "none",
                                  display: "block",
                                  marginTop: "3px",
                                }}
                              >
                                {row?.current_plan_status || "NA"}
                              </small>
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">
                              Regular subscription expiring in
                            </span>
                            <span
                              className="value"
                              style={{
                                color: "#f13434",
                              }}
                            >
                              {row?.subscription_expiry_days || "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Trainer Info</span>
                            <span className="value">
                              {" "}
                              {row?.trainer_name || "NA"}
                              <br />
                              <small style={{ textTransform: "lowercase" }}>
                                {row?.trainer_mobile || ""}
                                <br />
                                {row?.trainer_email || ""}
                              </small>
                              {row?.trainer_status && (
                                <>
                                  <br />
                                  <small
                                    style={{
                                      background:
                                        row?.trainer_status === "active"
                                          ? "#0A701B"
                                          : "#F13434",
                                      color: "#fff",
                                      padding: "5px 10px",
                                      borderRadius: "8px",
                                      marginTop: "3px",
                                    }}
                                  >
                                    {row?.trainer_status || "NA"}
                                  </small>
                                </>
                              )}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Member Last Checkin</span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  userId: row?.user_id,
                                  isModOpen: true,
                                  cardName: "member_checkin_details",
                                  sendableStatsQPs: `&start_date=${
                                    row?.last_checkin || ""
                                  }&end_date=${row?.last_checkin || ""}`,
                                }))
                              }
                            >
                              {convertStraight(row?.last_checkin) || "-"}
                              <br />
                              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
                              <br />
                              {row?.last_checkin_days_ago
                                ? `(${row.last_checkin_days_ago?.replace(
                                    /_/g,
                                    " "
                                  )})`
                                : ""}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Member Last Workout</span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  userId: row?.user_id,
                                  isModOpen: true,
                                  cardName: "member_workout_details",
                                  sendableStatsQPs: `&date_from=${
                                    row?.last_checkin || ""
                                  }&date_to=${row?.last_checkin || ""}`,
                                  workoutDate: row?.last_workout_date,
                                }))
                              }
                            >
                              {convertStraight(row?.last_workout_date) || "-"}
                              <br />
                              {row?.last_workout_status?.replace(/_/g, " ") ||
                                ""}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">fitness profile</span>
                            <span
                              className="value icon"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "fitness_profile_logs",
                                  rowData: row,
                                }))
                              }
                            >
                              {row?.fitness_profile !== "pending" ? (
                                <CheckCircleIcon />
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">
                              current trainer rating
                            </span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "trainer_rating_logs",
                                  rowData: row,
                                }))
                              }
                            >
                              {row?.current_trainer_avg_rating || "-"}{" "}
                              {row?.current_trainer_avg_rating && "★"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">First BCA Report</span>
                            <span className="value icon">
                              {row?.bca_report ? (
                                <a href={row?.bca_report}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-cloud-arrow-down"
                                    viewBox="0 0 16 16"
                                    style={{
                                      color: "#209216",
                                      minWidth: "35px",
                                      minHeight: "35px",
                                    }}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                                    />
                                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                  </svg>
                                </a>
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              disabled={!isFirstBCA}
                              onClick={() =>
                                isFirstBCA &&
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  cardName: "bca_report",
                                }))
                              }
                              style={{
                                color: "blue",
                                fontWeight: "bold",
                                opacity: isFirstBCA ? 1 : 0.5,
                              }}
                            >
                              View
                            </button>

                            <span className="btn-label">BCA Report</span>
                          </div>

                          {isAdmin && (
                            <div className="lead-log-box">
                              <button
                                className="lead-log view-lead"
                                disabled={loading}
                                style={{
                                  cursor: "pointer",
                                  textTransform: "capitalize",
                                }}
                                onClick={() =>
                                  setClickValues((prevs) => ({
                                    ...prevs,
                                    isModOpen: true,
                                    rowData: row,
                                    cardName: "member_map",
                                  }))
                                }
                              >
                                <DownloadIcon />
                              </button>

                              <span className="btn-label">Map</span>
                            </div>
                          )}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default CheckedinMembersMobile;
